const advertisingCampaigns = {
  headlines: 'Titulares',
  headline: 'Título',
  description: 'Descripción',
  adsHeadlinesAndDescriptions: 'Títulos y descripciones de anuncios',
  summary: 'Resumen',
  targetCPI: 'CPI objetivo',
  dailyBudget: 'Presupuesto diario',
  showHeadlines: 'Mostrar titulares',
  countries: 'Países',
  duration: 'Duración',
};

export default advertisingCampaigns;
